import { createResourceRequests } from '../../helpers/resource';
import * as normalizers from './normalizers';

const query = (params) => ({
  method: 'POST',
  url: '/api/TNEvents/Search',
  data: {
    searchterm: params.queryText,
  },
  normalizer: normalizers.fromQuery,
});

const endpoints = {
  query,
};

const api = createResourceRequests(endpoints);

export default api;



// WEBPACK FOOTER //
// ./src/resources/search/api.js